import {  GridColDef } from '@mui/x-data-grid-premium';
import React from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import tableHelper from 'src/core/tables/tableHelper';
import { useGetWarehouseValuesSummary } from 'src/pages/reports/reportRequests';



export const useWarehouseValuesSummaryTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const rows = useGetWarehouseValuesSummary();
  const idPath = ["WarehouseId"];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'WarehouseId', headerName: 'Warehouse Id', },
      { field: 'TotalClosingBalance', headerName: 'Total Closing Balance', type:'number',flex:1 },
      { field: 'OrganizationName', headerName: 'Organization Name',flex:1 },
      { field: 'WarehouseName', headerName: 'Warehouse Name',flex:1 },
      
      { field: 'ClosingDate', headerName: 'Closing Date', type: 'dateTime', valueGetter:  tableHelper.getDateColumn,flex:1},
      
    ],
    [],
  );
  const tableName = "WarehouseValuesSummaryReportTable";
  let tableSettings = useTableSettings({ columns, idPath,rows, tableName });
  
  return [ columns, tableSettings];
};


